export enum DeviceType {
  TOOL = 'Tool',
  LOGGER = 'Logger',
}

export type DeviceLookup = {
  Type: DeviceType;
};
